import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../../hooks/useCountdown";
import { pad, splitDuration } from "../../utils/countdown";

/** Barra fija con la cuenta regresiva de la oferta, se reinicia cada día a las 12:00 */
export function OfferCountdown() {
  const remaining = useCountdown();
  const {
    hours,
    minutes,
    seconds
  } = splitDuration(remaining);
  const units = [{
    value: hours,
    label: "h"
  }, {
    value: minutes,
    label: "m"
  }, {
    value: seconds,
    label: "s"
  }];
  return <div className="bg-terracota-deep text-papel" data-id="element-172" data-mp="3fvk1q9nv5qjl">
      <div className="mx-auto flex h-10 max-w-6xl items-center justify-center gap-2.5 px-4 text-sm md:gap-4 md:px-6" data-id="element-173" data-mp="3knldzvl17h9m">
        <p className="flex items-center gap-1.5 whitespace-nowrap font-semibold" data-id="element-174" data-mp="3pn7r850v0xif">
          <ClockIcon className="h-4 w-4 shrink-0 text-sakura" aria-hidden="true" data-id="element-175" data-mp="3um12dqsoccff" />
          Oferta única 50% OFF
          <span className="hidden font-normal text-sakura-light sm:inline" data-id="element-176" data-mp="2hgqflbpzghg">en todos los planes · termina en</span>
        </p>
        <div role="timer" aria-label={`La oferta termina en ${hours} horas, ${minutes} minutos y ${seconds} segundos`} className="flex items-center gap-1 tabular-nums" data-id="element-177" data-mp="uvsmkkt1euzp">
          {units.map((u, i) => <React.Fragment key={u.label} data-id="element-178" data-mp="kyo5v0hynrqa" data-mpi={i}>
              {i > 0 && <span className="text-sakura" aria-hidden="true" data-id="element-179" data-mp="fzl1zjdpvrjw">
                  :
                </span>}
              <span className="flex items-baseline gap-0.5 rounded-md bg-pizarra-deep px-1.5 py-0.5 font-semibold" aria-hidden="true" data-id="element-180" data-mp="1dnd0cgoigyt2">
                {pad(u.value)}
                <span className="text-[10px] font-medium text-crema" data-id="element-181" data-mp="yww0h1riygya">{u.label}</span>
              </span>
            </React.Fragment>)}
        </div>
      </div>
    </div>;
}